import { EFinancingProgram } from '@if/core/types'
import resourcesData from '@src/data/programsResourcesFilesNames.json'
import { ResourceDto } from '@src/types/ResourceDto'
import { useMemo } from 'react'

const getResources = (supportedFinancingPrograms: EFinancingProgram[], language: string): ResourceDto[] => {
  const data = resourcesData as Record<string, Record<string, string[]>>

  const resources: ResourceDto[] = []
  supportedFinancingPrograms.forEach((programId) => {
    const programFiles = data[programId]?.[language] || []
    programFiles.forEach((fileName) => {
      resources.push({
        id: `${programId}-${fileName}`,
        financingProgramId: programId,
        fileName,
        language,
      })
    })
  })

  return resources
}

const useResources = (supportedFinancingPrograms: EFinancingProgram[], language: string): [ResourceDto[], boolean] => {
  const resources = useMemo(
    () => getResources(supportedFinancingPrograms, language),
    [supportedFinancingPrograms, language],
  )

  return [resources, false]
}

export default useResources
